export default {
    key: "fashionMarket",
    basePath: "/fashionMarket",
    exclude: false,
    components: [],
  };
  